export default "__VITE_ASSET__C1KyvEG6__"